var _defs, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _g4, _path8, _g5, _path9, _g6, _circle, _circle2, _path10, _g7, _path11, _g8, _path12, _g9, _g10, _circle3, _circle4, _path13, _ellipse, _g11, _circle5, _circle6, _path14, _ellipse2, _g12, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSovaFixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": " \\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 379.84 78.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33 {\n        stroke-width: 0px;\n      }\n\n      .cls-34 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_6);\n      }\n\n      .cls-4 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_7);\n      }\n\n      .cls-5 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_2);\n      }\n\n      .cls-6 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_9);\n      }\n\n      .cls-7 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_8);\n      }\n\n      .cls-8 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_3);\n      }\n\n      .cls-9 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_5);\n      }\n\n      .cls-10 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_4);\n      }\n\n      .cls-35 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-36 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-37 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-38 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-39 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-40 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-41 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-42 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-43 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-44 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-45 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-11 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_25);\n      }\n\n      .cls-12 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_24);\n      }\n\n      .cls-13 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_20);\n      }\n\n      .cls-14 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_23);\n      }\n\n      .cls-15 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_22);\n      }\n\n      .cls-16 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_21);\n      }\n\n      .cls-17 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_16);\n      }\n\n      .cls-18 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_13);\n      }\n\n      .cls-19 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_18);\n      }\n\n      .cls-20 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_15);\n      }\n\n      .cls-21 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_19);\n      }\n\n      .cls-22 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_17);\n      }\n\n      .cls-23 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_10);\n      }\n\n      .cls-24 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_11);\n      }\n\n      .cls-25 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12);\n      }\n\n      .cls-26 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_14);\n      }\n\n      .cls-28 {\n        fill: #292830;\n      }\n\n      .cls-29 {\n        fill: #b7ab9e;\n      }\n\n      .cls-30 {\n        fill: #665a4d;\n      }\n\n      .cls-31 {\n        fill: #fff;\n      }\n\n      .cls-32 {\n        fill: #ffe20d;\n      }\n\n      .cls-33 {\n        fill: #020202;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.73,17.67c0-3.32,2.88-13.98-.98-13.98-1.82,0-4.59,1.37-6.74,0-3.66-2.34,7.72,24.33,7.72,13.98Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442",
    cx: 8009.15,
    cy: -288.48,
    fx: 8009.15,
    fy: -288.48,
    r: 9.33,
    gradientTransform: "translate(269.23 1617.77) rotate(-90) scale(.2 .78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#665a4d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#000",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665a4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 2",
    cx: 2101.59,
    cy: 3026.69,
    fx: 2101.59,
    fy: 3026.69,
    r: 22.01,
    gradientTransform: "translate(910.98 629.27) rotate(-180) scale(.42 .21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665a4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m1.03,17.67c0-3.32-2.88-13.98.98-13.98,1.82,0,4.59,1.37,6.74,0C12.41,1.35,1.03,28.02,1.03,17.67Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 3",
    cx: 4148.53,
    cy: -183.15,
    fx: 4148.53,
    fy: -183.15,
    r: 9.33,
    gradientTransform: "translate(-829.62 -132.2) scale(.2 -.78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#665a4d",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#000",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665a4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 4",
    cx: 2190.57,
    cy: 3722.64,
    fx: 2190.57,
    fy: 3722.64,
    r: 22.01,
    gradientTransform: "translate(0 81.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665a4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.46,45.58c0,9.53-8.76,32.99-19.56,32.99S3.34,55.11,3.34,45.58s8.76-15.29,19.56-15.29,19.56,5.77,19.56,15.29Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_5",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 5",
    cx: -2175.13,
    cy: -907.64,
    fx: -2175.13,
    fy: -907.64,
    r: 22.01,
    gradientTransform: "translate(-2029.88 602.11) rotate(-180) scale(.93 -.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7ab9e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_6",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 6",
    cx: -2122.15,
    cy: -1141.27,
    fx: -2122.15,
    fy: -1141.27,
    r: 22.01,
    gradientTransform: "translate(-1946.48 739.49) rotate(-180) scale(.93 -.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7ab9e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_7",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 7",
    cx: -1680.26,
    cy: -441.22,
    fx: -1680.26,
    fy: -441.22,
    r: 22.01,
    gradientTransform: "translate(361.18 1842.76) rotate(90) scale(1.07 -.77)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_8",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 8",
    cx: -1511.88,
    cy: -2119.97,
    fx: -1511.88,
    fy: -2119.97,
    r: 22.01,
    gradientTransform: "translate(-1390.23 1015.24) rotate(-180) scale(.93 -.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7ab9e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.74,47.71c0,7.23-6.64,19.03-14.84,19.03s-14.84-11.8-14.84-19.03,6.64-11.6,14.84-11.6,14.84,4.37,14.84,11.6Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_9",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 9",
    cx: 179.04,
    cy: -97.99,
    fx: 179.04,
    fy: -97.99,
    r: 25.34,
    gradientTransform: "translate(-107.21 -8.23) scale(.72 -.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m12.35,54.42c1.41,4.18-1.44,14.56-3.85,14.56-3.84,0-9.83-15.65-4.81-28.33.08-.21.29-.35.52-.35h.14c-1.62,8.79,6.53,9.78,8,14.12h0Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_10",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 10",
    cx: 909.6,
    cy: -480.4,
    fx: 909.6,
    fy: -480.4,
    r: 13.46,
    gradientTransform: "translate(-420.54 -314.44) scale(.47 -.74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_11",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 11",
    cx: 425.94,
    cy: -719.8,
    fx: 425.94,
    fy: -719.8,
    r: 13.46,
    gradientTransform: "translate(-259.61 -681.49) scale(.61 -1.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m33.52,54.42c-1.41,4.18,1.44,14.56,3.85,14.56,3.84,0,9.83-15.65,4.81-28.33-.08-.21-.29-.35-.52-.35h-.14c1.62,8.79-6.53,9.78-8,14.12h0Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 12",
    cx: -1628.75,
    cy: -257.21,
    fx: -1628.75,
    fy: -257.21,
    r: 13.46,
    gradientTransform: "translate(229.55 -723.62) rotate(-90) scale(.47 .74)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_13",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 13",
    cx: -1526.88,
    cy: -557.7,
    fx: -1526.88,
    fy: -557.7,
    r: 13.46,
    gradientTransform: "translate(616.66 -877.82) rotate(-90) scale(.61 1.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7ab9e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    cx: 35.17,
    cy: 19.71,
    fx: 35.17,
    fy: 19.71,
    r: 4.61,
    gradientTransform: "translate(-10.47 63.69) scale(.93 -.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffe20d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#ffeb5b",
    stopOpacity: 0.68
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.77,17.67c0,10.34-8.62,16.69-21.87,16.69S1.03,28.01,1.03,17.67,9.65,0,22.9,0s21.87,7.33,21.87,17.67Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_15",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 15",
    x1: 32.13,
    y1: 46.51,
    x2: 26.77,
    y2: 56.03,
    gradientTransform: "translate(-16.89 69.26) rotate(19.05) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7ab9e",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_16",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 16",
    cx: -61.94,
    cy: -274.21,
    fx: -61.94,
    fy: -274.21,
    r: 22.01,
    gradientTransform: "translate(94.63 -167.5) scale(1.16 -.68)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_17",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 17",
    cx: 597.87,
    cy: 756.56,
    fx: 597.87,
    fy: 756.56,
    r: 24.02,
    gradientTransform: "translate(-234.27 331.82) scale(.45 -.42)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_18",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 18",
    cx: 548.42,
    cy: 1012.04,
    fx: 548.42,
    fy: 1012.04,
    r: 24.02,
    gradientTransform: "translate(0 81.04) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.9,17.67c0,7.38-7.61,11.42-17,11.42S5.9,25.06,5.9,17.67c0-5,4.81-8.15,8.66-8.15,3.19,0,8.34,2.6,8.34,2.6,0,0,5.15-2.6,8.34-2.6,3.85,0,8.66,3.15,8.66,8.15Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_19",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 19",
    cx: 6300.94,
    cy: 3974.68,
    fx: 6300.94,
    fy: 3974.68,
    r: 16.92,
    gradientTransform: "translate(552.59 1280.14) rotate(-90.28) scale(.2 -.13) skewX(-.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#000",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665a4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.46,23.33c0,.99-.84,2.58-1.56,2.58s-1.56-1.59-1.56-2.58.84-1.19,1.56-1.19,1.56.19,1.56,1.19Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_20",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 20",
    cx: 109.82,
    cy: -4095.59,
    fx: 109.82,
    fy: -4095.59,
    r: 6.41,
    gradientTransform: "translate(1847.92 -89.12) rotate(90) scale(.99 -.45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#665a4d",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_21",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 21",
    cx: 1157.54,
    cy: -8122.65,
    fx: 1157.54,
    fy: -8122.65,
    r: 6.41,
    gradientTransform: "translate(1168.76 1848.61) rotate(-180) scale(.99 -.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ebeae8",
    stopOpacity: 0.86
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ada8a1",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#867e73",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776e62",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m39.9,17.67c0,7.38-7.61,11.42-17,11.42S5.9,25.06,5.9,17.67c0-5,4.81-8.15,8.66-8.15,3.19,0,8.34,2.6,8.34,2.6,0,0,5.15-2.6,8.34-2.6,3.85,0,8.66,3.15,8.66,8.15Z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_22",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 22",
    cx: 835.54,
    cy: -1998.93,
    fx: 835.54,
    fy: -1998.93,
    r: 14.03,
    gradientTransform: "translate(-875.1 409.76) rotate(-90.42) scale(.47 -.47) skewX(.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbed21",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffe20d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_23",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 23",
    cx: 835.54,
    cy: -1972,
    fx: 835.54,
    fy: -1972,
    r: 14.03,
    gradientTransform: "translate(-879.47 409.71) rotate(-90.42) scale(.47 -.47) skewX(.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbed21",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#ffe20d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbed21",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 14.56,
    cy: 18.15,
    r: 4.34
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_24",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 24",
    cx: -115.72,
    cy: -60.12,
    fx: -115.72,
    fy: -60.12,
    r: 7.02,
    gradientTransform: "translate(100.16 -21.34) scale(.74 -.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 31.24,
    cy: 18.15,
    r: 4.34
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_25",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 25",
    cx: -93.08,
    cy: -60.12,
    fx: -93.08,
    fy: -60.12,
    r: 7.02,
    gradientTransform: "translate(100.16 -21.34) scale(.74 -.59)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m55.29,54.5h7.01c.21,8.14,6.37,11.47,13.87,11.47,6.8,0,11.89-3.11,11.89-8.92,0-4.46-3.19-7.15-8.99-8.42l-8.21-1.84c-8.99-1.98-13.52-5.73-13.52-13.02,0-8.49,7.29-14.09,17.91-14.09s16.99,5.66,17.84,14.65h-6.87c-.64-6.23-4.96-9.41-11.25-9.41s-10.97,3.4-10.97,8.35c0,4.32,3.61,6.51,8.78,7.72l8.28,1.98c8.64,2.05,13.94,5.52,13.94,14.02,0,9.06-7.5,14.51-19.54,14.51s-20.03-5.59-20.17-16.99h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m99.95,45.65c0-7.36,3.19-13.59,10.62-16.85-2.05,4.25-3.04,9.98-3.04,16.85s1.06,12.6,3.11,16.85c-7.5-3.26-10.69-9.56-10.69-16.85Zm41.27,0c0-6.87-.99-12.6-3.04-16.85-2.76-5.95-7.43-9.13-13.8-9.13s-11.04,3.19-13.8,9.13c3.54-1.56,8.14-2.48,13.8-2.48s10.26.92,13.8,2.48c7.43,3.26,10.62,9.49,10.62,16.85s-3.19,13.66-10.69,16.92c-3.61,1.56-8.14,2.41-13.73,2.41s-10.19-.92-13.73-2.48c2.76,5.88,7.43,8.99,13.73,8.99s10.9-3.11,13.73-8.92c2.05-4.25,3.11-9.98,3.11-16.92h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m168.33,70.36l-17.77-49.55h7.5l13.8,42.54,13.8-42.54h7.5l-17.77,49.55h-7.08.02Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m228.01,70.36l-5.38-14.09h-20.46l-5.31,14.09h-7.22l19.54-49.55h6.51l19.54,49.55h-7.22Zm-7.37-19.4l-8.21-23.85-8.14,23.85h16.35Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m44.73,17.67c0-3.32,2.88-13.98-.98-13.98-1.82,0-4.59,1.37-6.74,0-3.66-2.34,7.72,24.33,7.72,13.98Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 43.28,
    cy: 11.37,
    rx: 7.69,
    ry: 2.36,
    transform: "translate(25.98 52.64) rotate(-81.97)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 36.32,
    cy: 3.31,
    rx: 9.13,
    ry: 4.58
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m1.03,17.67c0-3.32-2.88-13.98.98-13.98,1.82,0,4.59,1.37,6.74,0C12.41,1.35,1.03,28.02,1.03,17.67Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 2.48,
    cy: 11.36,
    rx: 2.36,
    ry: 7.69,
    transform: "translate(-1.56 .46) rotate(-8.03)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 9.13,
    cy: 3.31,
    rx: 9.13,
    ry: 4.58
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m42.46,45.58c0,9.53-8.76,32.99-19.56,32.99S3.34,55.11,3.34,45.58s8.76-15.29,19.56-15.29,19.56,5.77,19.56,15.29Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-38"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 3.43,
    cy: 68.98,
    rx: 20.5,
    ry: 13.02,
    transform: "translate(-62.77 49.28) rotate(-70.58)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 37.22,
    cy: 68.96,
    rx: 20.5,
    ry: 13.02,
    transform: "translate(-41.02 64.49) rotate(-58.37)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 22.9,
    cy: 48.46,
    rx: 17,
    ry: 23.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 22.27,
    cy: 31.43,
    rx: 20.5,
    ry: 10.3
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 22.9,
    cy: 49.13,
    rx: 18.29,
    ry: 14.99
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m12.35,54.42c1.41,4.18-1.44,14.56-3.85,14.56-3.84,0-9.83-15.65-4.81-28.33.08-.21.29-.35.52-.35h.14c-1.62,8.79,6.53,9.78,8,14.12h0Z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 8.49,
    cy: 43.87,
    rx: 6.32,
    ry: 10.07,
    transform: "translate(-9.19 2.83) rotate(-12.35)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 1.83,
    cy: 57.26,
    rx: 8.22,
    ry: 13.87,
    transform: "translate(-12.21 1.72) rotate(-12.35)"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m33.52,54.42c-1.41,4.18,1.44,14.56,3.85,14.56,3.84,0,9.83-15.65,4.81-28.33-.08-.21-.29-.35-.52-.35h-.14c1.62,8.79-6.53,9.78-8,14.12h0Z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 37.36,
    cy: 43.84,
    rx: 10.07,
    ry: 6.32,
    transform: "translate(-13.46 70.96) rotate(-77.65)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 44.01,
    cy: 57.23,
    rx: 13.87,
    ry: 8.22,
    transform: "translate(-21.31 87.98) rotate(-77.65)"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-26",
    cx: 22.9,
    cy: 46.37,
    r: 4.31
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 22.9,
    cy: 46.37,
    r: 2.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m44.77,17.67c0,10.34-8.62,16.69-21.87,16.69S1.03,28.01,1.03,17.67,9.65,0,22.9,0s21.87,7.33,21.87,17.67Z"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 26.65,
    cy: 24.79,
    rx: 23.06,
    ry: 11.76,
    transform: "translate(-6.63 10.06) rotate(-19.05)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 22.9,
    cy: 16.99,
    rx: 25.5,
    ry: 14.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 31.93,
    cy: 16.52,
    rx: 10.67,
    ry: 10.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 13.7,
    cy: 16.52,
    rx: 10.67,
    ry: 10.06
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m39.9,17.67c0,7.38-7.61,11.42-17,11.42S5.9,25.06,5.9,17.67c0-5,4.81-8.15,8.66-8.15,3.19,0,8.34,2.6,8.34,2.6,0,0,5.15-2.6,8.34-2.6,3.85,0,8.66,3.15,8.66,8.15Z"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 22.9,
    cy: 24.42,
    rx: 2.4,
    ry: 3.55
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m24.46,23.33c0,.99-.84,2.58-1.56,2.58s-1.56-1.59-1.56-2.58.84-1.19,1.56-1.19,1.56.19,1.56,1.19Z"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 22.9,
    cy: 19.55,
    rx: 2.87,
    ry: 6.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 24.42,
    cy: 25.25,
    rx: 6.32,
    ry: 1.45,
    transform: "translate(-9.65 33.78) rotate(-60)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 31.24,
    cy: 18.15,
    rx: 6.91,
    ry: 6.88
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 14.56,
    cy: 18.15,
    rx: 6.91,
    ry: 6.88
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 14.56,
    cy: 18.15,
    r: 4.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 14.56,
    cy: 18.15,
    r: 3.07
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m14.56,15.07c1.7,0,3.07,1.38,3.07,3.07s-1.38,3.07-3.07,3.07v-6.14h0Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 16.14,
    cy: 16.93,
    rx: 0.53,
    ry: 0.61
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 14.56,
    cy: 13.81,
    rx: 5.15,
    ry: 4.15
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 31.24,
    cy: 18.15,
    r: 4.9
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 31.24,
    cy: 18.15,
    r: 3.07
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m31.24,15.07c1.7,0,3.07,1.38,3.07,3.07s-1.38,3.07-3.07,3.07v-6.14h0Z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-31",
    cx: 32.82,
    cy: 16.93,
    rx: 0.53,
    ry: 0.61
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 31.24,
    cy: 13.81,
    rx: 5.15,
    ry: 4.15
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m294.76,52.52h-53.8v-5.28h53.8v5.28Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m337.78,70.26h-5.92v-30.56h-18.31v30.56h-5.99v-30.56h-7.53v-5.35h7.53v-4.86c0-7.53,2.39-12.6,11.62-12.6,1.48,0,2.75.14,4.79.42v5.35c-.63-.14-2.18-.42-3.87-.42-5.49,0-6.55,1.62-6.55,8.52v3.59h24.22v35.91h0Zm-3.02-43.66c-2.25,0-3.87-1.62-3.87-3.87s1.62-3.8,3.87-3.8,3.94,1.55,3.94,3.8-1.69,3.87-3.94,3.87Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m379.82,70.26h-7.32l-10.77-14.08-10.49,14.08h-7.39l14.58-18.8-13.17-17.11h7.46l9.65,12.82,9.37-12.82h6.83l-12.96,17.11,14.23,18.8h-.02Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSovaFixLogo);
export default __webpack_public_path__ + "static/media/SovaFixLogo.e282fdd1d54c9904a62e49c3ebe03b9d.svg";
export { ForwardRef as ReactComponent };